import { z } from "zod";

export const interventionFormSchema = z.object({
  date: z.date(),
  timeIn: z.string().regex(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/),
  timeOut: z.string().regex(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/),
  seenAt: z.string(),
  staffInitials: z.string().min(2).max(4),
  referredTo: z.string(),
  supervised: z.string(),
  
}).passthrough();

export type InterventionFormData = z.infer<typeof interventionFormSchema>;
